import React from 'react';
import PropTypes from 'prop-types';
import StudentEngagementSummary from './StudentEngagementSummary';
import { toJS } from 'mobx';
import { StudentEngagementListService } from '../../services/CustomerSuccessKpiListService';
import { observer } from 'mobx-react';
import { get } from 'lodash';

class StudentEngagementSummaryContainer extends React.Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    typeId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    StudentEngagementListService.load();
  }

  render() {
    const data = toJS(StudentEngagementListService.getSummaryByType(this.props.type, this.props.typeId));
    return (
      <StudentEngagementSummary
        isLoading={
          StudentEngagementListService.fetchCurrent.fetching || StudentEngagementListService.fetchPrevious.fetching
        }
        currentValue={get(data, 'current')}
        previousValue={get(data, 'previous')}
        standardDeviationValue={get(data, 'currentStandardDeviation', 0) / 3600}
        formatter={StudentEngagementListService.getFormattedValue}
      />
    );
  }
}

export default observer(StudentEngagementSummaryContainer);
